import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import SessionGuard from "@/components/SessionGuard";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Tickets from "@/pages/Tickets";
import Kanban from "@/pages/Kanban";
import TicketPool from "@/pages/TicketPool";
import Users from "@/pages/Users";
import Settings from "@/pages/Settings";
import AppSettings from "@/pages/AppSettings";
import FieldReport from "@/pages/FieldReport";
import ReportsReview from "@/pages/ReportsReview";
import Attendance from "@/pages/Attendance";
import AttendanceReport from "@/pages/AttendanceReport";
import AttendanceRequests from "@/pages/AttendanceRequests";
import AttendanceDuties from "@/pages/AttendanceDuties";
import Panduan from "@/pages/Panduan";
import Overtime from "@/pages/Overtime";
import Operations from "@/pages/Operations";
import BillingCustomers from "@/pages/BillingCustomers";
import BillingInvoices from "@/pages/BillingInvoices";
import BillingKolektor from "@/pages/BillingKolektor";
import BillingMasters from "@/pages/BillingMasters";
import BillingRekap from "@/pages/BillingRekap";
import BillingDashboardAdmin from "@/pages/BillingDashboardAdmin";
import NetworkMap from "@/pages/NetworkMap";
import NetworkOdc from "@/pages/NetworkOdc";
import NetworkOlt from "@/pages/NetworkOlt";
import NetworkSplitter from "@/pages/NetworkSplitter";
import NetworkOdp from "@/pages/NetworkOdp";
import NetworkCable from "@/pages/NetworkCable";
import NetworkOtb from "@/pages/NetworkOtb";
import NetworkServer from "@/pages/NetworkServer";
import NetworkFdt from "@/pages/NetworkFdt";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <SessionGuard />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout><Dashboard /></Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/tickets"
              element={
                <ProtectedRoute>
                  <Layout><Tickets /></Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/kanban"
              element={
                <ProtectedRoute>
                  <Layout><Kanban /></Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/pool"
              element={
                <ProtectedRoute>
                  <Layout><TicketPool /></Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/users"
              element={
                <ProtectedRoute adminOnly>
                  <Layout><Users /></Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/settings"
              element={
                <ProtectedRoute>
                  <Layout><Settings /></Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/report"
              element={
                <ProtectedRoute>
                  <Layout><FieldReport /></Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/reports-review"
              element={
                <ProtectedRoute>
                  <Layout><ReportsReview /></Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/attendance"
              element={
                <ProtectedRoute>
                  <Layout><Attendance /></Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/attendance-report"
              element={
                <ProtectedRoute>
                  <Layout><AttendanceReport /></Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/attendance-requests"
              element={
                <ProtectedRoute>
                  <Layout><AttendanceRequests /></Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/attendance-duties"
              element={
                <ProtectedRoute>
                  <Layout><AttendanceDuties /></Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/panduan"
              element={
                <ProtectedRoute>
                  <Layout><Panduan /></Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/overtime"
              element={
                <ProtectedRoute>
                  <Layout><Overtime /></Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/operations"
              element={
                <ProtectedRoute>
                  <Layout><Operations /></Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/app-settings"
              element={
                <ProtectedRoute adminOnly>
                  <Layout><AppSettings /></Layout>
                </ProtectedRoute>
              }
            />
            <Route path="/billing" element={<Navigate to="/billing/invoices" replace />} />
            <Route path="/billing/customers" element={<ProtectedRoute><Layout><BillingCustomers /></Layout></ProtectedRoute>} />
            <Route path="/network/map" element={<ProtectedRoute><Layout><NetworkMap /></Layout></ProtectedRoute>} />
            <Route path="/network/olt" element={<ProtectedRoute><Layout><NetworkOlt /></Layout></ProtectedRoute>} />
            <Route path="/network/splitter" element={<ProtectedRoute><Layout><NetworkSplitter /></Layout></ProtectedRoute>} />
            <Route path="/network/odc" element={<ProtectedRoute><Layout><NetworkOdc /></Layout></ProtectedRoute>} />
            <Route path="/network/odp" element={<ProtectedRoute><Layout><NetworkOdp /></Layout></ProtectedRoute>} />
            <Route path="/network/otb" element={<ProtectedRoute><Layout><NetworkOtb /></Layout></ProtectedRoute>} />
            <Route path="/network/server" element={<ProtectedRoute><Layout><NetworkServer /></Layout></ProtectedRoute>} />
            <Route path="/network/fdt" element={<ProtectedRoute><Layout><NetworkFdt /></Layout></ProtectedRoute>} />
            <Route path="/network/cable" element={<ProtectedRoute><Layout><NetworkCable /></Layout></ProtectedRoute>} />
            <Route path="/billing/invoices" element={<ProtectedRoute><Layout><BillingInvoices /></Layout></ProtectedRoute>} />
            <Route path="/billing/tagihan-saya" element={<ProtectedRoute><Layout><BillingKolektor /></Layout></ProtectedRoute>} />
            <Route path="/billing/rekap" element={<ProtectedRoute><Layout><BillingRekap /></Layout></ProtectedRoute>} />
            <Route path="/billing/dashboard" element={<ProtectedRoute adminOnly><Layout><BillingDashboardAdmin /></Layout></ProtectedRoute>} />
            <Route path="/billing/masters" element={<ProtectedRoute><Layout><BillingMasters /></Layout></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
